import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { Loader2, ArrowLeft, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (e2) { setError(errMsg(e2)); }
    finally { setLoading(false); }
  };

  return (
    <div className="sea-bg flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <div className="glass rounded-2xl p-8 shadow-2xl">
          <KeyRound className="h-10 w-10 text-[hsl(var(--gold))]" />
          <h2 className="mt-3 font-display text-3xl font-700">New Password</h2>
          <p className="mt-1 text-sm text-muted-foreground">Choose a strong password for your account.</p>
          {!token ? (
            <p className="mt-6 text-sm text-destructive">Invalid reset link. Please request a new one.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
              <div>
                <Label htmlFor="pw">New Password</Label>
                <Input id="pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="reset-password-input" />
              </div>
              <div>
                <Label htmlFor="cpw">Confirm Password</Label>
                <Input id="cpw" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="reset-confirm-input" />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full bg-[hsl(var(--gold))] font-700 text-[#0A192F]" data-testid="reset-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
              </Button>
            </form>
          )}
          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
